import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface ToolTipProps {
  description: string;
  placement?: "top" | "bottom" | "left" | "right";
}

const ToolTip: React.FC<ToolTipProps> = ({
  description,
  placement = "top",
}) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip
          id={`tooltip-${description.replace(/\s+/g, "-").toLowerCase()}`}
        >
          {description}
        </Tooltip>
      }
    >
      <i
        className="bi bi-info-circle ps-1 pe-1"
        style={{ cursor: "pointer" }}
        aria-label={description}
      />
    </OverlayTrigger>
  );
};

export default ToolTip;
